import { makeStyles } from "tss-react/mui";
import Alert from '@mui/material/Alert';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";

const useStyles = makeStyles()((theme: any) => ({
    root: {
        width: "100%",
        maxWidth: "max-content",
        borderRadius: 4,
        minWidth : "100%",
        margin:'10px 0'
    },
   
    successAlert: {
        color: "rgb(30, 70, 32) !important",
        backgroundColor: "rgb(237, 247, 237) !important",
    },
    errorAlert: {
        color: "rgb(95, 33, 32) !important",
        backgroundColor: "rgb(253, 237, 237) !important"
    },
    warningAlert: {
        color: "rgb(102, 60, 0) !important",
        backgroundColor: "rgb(255, 244, 229) !important"
    }
}));

type IProps = {
    type: string;
    message : string;
    variant : any;
};


export default function AlertNotification(props: IProps) {
    const { classes } = useStyles();
    const { message, type, variant } = props;

    useEffect(() => {

        AOS.init({
            duration: 1200, // duration of animations
            once: true,     // whether animation should happen only once - while scrolling down
            easing: 'ease-in-out', // custom easing function
            offset: 100,    // custom offset from trigger point
        });
    });

    const checkType = () => {
        switch (type) {
            case "success":
                return <Alert variant={variant} severity={type} className={classes.successAlert} data-aos="fade-right">{message}</Alert>
            case "error":
                return <Alert variant={variant} severity={type} className={classes.errorAlert} data-aos="fade-right">{message}</Alert>
            case "warning":
                return <Alert variant={variant} severity={type} className={classes.warningAlert} data-aos="fade-right">{message}</Alert>
            default:
                return "";
        }
    };
   
    return (
        <div className={classes.root}>
            {checkType()}
        </div>
    );
}
